module.exports = __webpack_public_path__ + "media/images/ecute/ecutetokyo_en_PC-2573b1e8c2e8689c3cc796a69a661f27.jpg";